/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagsRealtimeDataLastValuesList } from '../../models/tags-realtime-data-last-values-list';

export interface GetOpcuaConfigurationTagsValues$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected opcua configuration
 */
  opcuaUid: string;
}

export function getOpcuaConfigurationTagsValues(http: HttpClient, rootUrl: string, params: GetOpcuaConfigurationTagsValues$Params, context?: HttpContext): Observable<StrictHttpResponse<TagsRealtimeDataLastValuesList>> {
  const rb = new RequestBuilder(rootUrl, getOpcuaConfigurationTagsValues.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('opcuaUid', params.opcuaUid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TagsRealtimeDataLastValuesList>;
    })
  );
}

getOpcuaConfigurationTagsValues.PATH = '/stations/{uid}/opcua/{opcuaUid}/tags';
